import { render } from "./EventPage.vue?vue&type=template&id=067df956&bindings={\"eventId, event\":\"props\"}"
import script from "./EventPage.vue?vue&type=script&lang=js"
export * from "./EventPage.vue?vue&type=script&lang=js"
script.render = render

export default script